import React from 'react';
import { createPortal } from 'react-dom';
import './toaster.css'

const Toaster = (props) => {  
  const {
    toastRef,
    toastMessage,
    type
  } = props;

  return createPortal(
      <div
        className={`toast align-items-center border-0 ${type === 'error' ? 'error' : 'success'}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        ref={toastRef}
      >
        <div className="d-flex">
          <div className="toast-body">{toastMessage}</div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>,
      document.body
  );
};

export default Toaster;
